import {Component, Input} from '@angular/core';
import {KYCPrivateProfile, KYCStatus} from "../../../api/entity/kyc-verification";


@Component({
    selector: 'tfl-bo-kyc-results-private',
    template: `
        <tfl-bo-kyc-results-block
            title="{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.PROFILE' | translate }}"
            [result]="{status: summaryStatus, person: results.person}">
        </tfl-bo-kyc-results-block>
    `
})
export class KYCResultsPrivateComponent {
    @Input() results: KYCPrivateProfile;
    @Input() summaryStatus: KYCStatus;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/kyc/results/kyc-results.private.component.ts